import { inject } from "@angular/core";
import { Routes } from "@angular/router";
import { WA_NAVIGATOR } from "@ng-web-apis/common";
import { catchError, of, tap } from "rxjs";
import { AppStore } from "./core/+store/app.store";
import { DisplayService } from "./core/services/display/display.service";
import { OfflinePlaybackService } from "./core/services/offline-playback/offline-playback.service";

export const routes: Routes = [
  {
    path: "",
    loadComponent: () => import("./routes/player/player.component").then((m) => m.PlayerComponent),
    canMatch: [
      () => {
        const store = inject(AppStore);
        return !!store.token();
      },
    ],
    resolve: {
      display: () => {
        const displayService = inject(DisplayService);
        const offlinePlayback = inject(OfflinePlaybackService);
        const navigator = inject(WA_NAVIGATOR);
        const persistedDisplay = offlinePlayback.getDisplay();

        if (!navigator.onLine && persistedDisplay) {
          return of(persistedDisplay);
        }

        return displayService.getDisplay().pipe(
          tap((display) => offlinePlayback.saveDisplay(display)),
          catchError(() => of(persistedDisplay ?? null)),
        );
      },
    },
  },
  {
    path: "",
    loadComponent: () => import("./routes/link/link.component").then((m) => m.LinkComponent),
  },
  {
    path: "privacy",
    loadComponent: () =>
      import("./routes/privacy/privacy.component").then((m) => m.PrivacyComponent),
  },
  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },
];
